// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { WarrantyTicketTypeFragmentDoc } from '../WarrantyTicketPage.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type WarrantyModalTicketTypesAndDevelopmentsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type WarrantyModalTicketTypesAndDevelopmentsQuery = { __typename?: 'Query', warrantyTicketTypesDetail: Array<{ __typename?: 'WarrantyTicketTypeDetail', code: Types.WarrantyTicketType, name: string }>, developments: Array<{ __typename?: 'Development', id: string, name: string }> };

export type WarrantyModalProjectsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.ProjectFilter>;
}>;


export type WarrantyModalProjectsQuery = { __typename?: 'Query', projectsPage: { __typename?: 'ProjectsPageResult', entities: Array<{ __typename?: 'StandaloneProject', id: string, name: string } | { __typename?: 'Region', id: string, name: string } | { __typename?: 'Market', id: string, name: string } | { __typename?: 'Community', id: string, name: string } | { __typename?: 'Subdivision', id: string, name: string } | { __typename?: 'Lot', id: string, name: string } | { __typename?: 'Structure', id: string, name: string } | { __typename?: 'Unit', id: string, name: string }> } };

export type WarrantyModal_Project_StandaloneProject_Fragment = { __typename?: 'StandaloneProject', id: string, name: string };

export type WarrantyModal_Project_Region_Fragment = { __typename?: 'Region', id: string, name: string };

export type WarrantyModal_Project_Market_Fragment = { __typename?: 'Market', id: string, name: string };

export type WarrantyModal_Project_Community_Fragment = { __typename?: 'Community', id: string, name: string };

export type WarrantyModal_Project_Subdivision_Fragment = { __typename?: 'Subdivision', id: string, name: string };

export type WarrantyModal_Project_Lot_Fragment = { __typename?: 'Lot', id: string, name: string };

export type WarrantyModal_Project_Structure_Fragment = { __typename?: 'Structure', id: string, name: string };

export type WarrantyModal_Project_Unit_Fragment = { __typename?: 'Unit', id: string, name: string };

export type WarrantyModal_ProjectFragment = WarrantyModal_Project_StandaloneProject_Fragment | WarrantyModal_Project_Region_Fragment | WarrantyModal_Project_Market_Fragment | WarrantyModal_Project_Community_Fragment | WarrantyModal_Project_Subdivision_Fragment | WarrantyModal_Project_Lot_Fragment | WarrantyModal_Project_Structure_Fragment | WarrantyModal_Project_Unit_Fragment;

export const WarrantyModal_ProjectFragmentDoc = gql`
    fragment WarrantyModal_Project on Project {
  id
  name
}
    `;
export const WarrantyModalTicketTypesAndDevelopmentsDocument = gql`
    query WarrantyModalTicketTypesAndDevelopments {
  warrantyTicketTypesDetail {
    ...WarrantyTicketType
  }
  developments {
    id
    name
  }
}
    ${WarrantyTicketTypeFragmentDoc}`;

/**
 * __useWarrantyModalTicketTypesAndDevelopmentsQuery__
 *
 * To run a query within a React component, call `useWarrantyModalTicketTypesAndDevelopmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWarrantyModalTicketTypesAndDevelopmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWarrantyModalTicketTypesAndDevelopmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useWarrantyModalTicketTypesAndDevelopmentsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WarrantyModalTicketTypesAndDevelopmentsQuery, WarrantyModalTicketTypesAndDevelopmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WarrantyModalTicketTypesAndDevelopmentsQuery, WarrantyModalTicketTypesAndDevelopmentsQueryVariables>(WarrantyModalTicketTypesAndDevelopmentsDocument, options);
      }
export function useWarrantyModalTicketTypesAndDevelopmentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WarrantyModalTicketTypesAndDevelopmentsQuery, WarrantyModalTicketTypesAndDevelopmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WarrantyModalTicketTypesAndDevelopmentsQuery, WarrantyModalTicketTypesAndDevelopmentsQueryVariables>(WarrantyModalTicketTypesAndDevelopmentsDocument, options);
        }
// @ts-ignore
export function useWarrantyModalTicketTypesAndDevelopmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WarrantyModalTicketTypesAndDevelopmentsQuery, WarrantyModalTicketTypesAndDevelopmentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WarrantyModalTicketTypesAndDevelopmentsQuery, WarrantyModalTicketTypesAndDevelopmentsQueryVariables>;
export function useWarrantyModalTicketTypesAndDevelopmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WarrantyModalTicketTypesAndDevelopmentsQuery, WarrantyModalTicketTypesAndDevelopmentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WarrantyModalTicketTypesAndDevelopmentsQuery | undefined, WarrantyModalTicketTypesAndDevelopmentsQueryVariables>;
export function useWarrantyModalTicketTypesAndDevelopmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WarrantyModalTicketTypesAndDevelopmentsQuery, WarrantyModalTicketTypesAndDevelopmentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WarrantyModalTicketTypesAndDevelopmentsQuery, WarrantyModalTicketTypesAndDevelopmentsQueryVariables>(WarrantyModalTicketTypesAndDevelopmentsDocument, options);
        }
export type WarrantyModalTicketTypesAndDevelopmentsQueryHookResult = ReturnType<typeof useWarrantyModalTicketTypesAndDevelopmentsQuery>;
export type WarrantyModalTicketTypesAndDevelopmentsLazyQueryHookResult = ReturnType<typeof useWarrantyModalTicketTypesAndDevelopmentsLazyQuery>;
export type WarrantyModalTicketTypesAndDevelopmentsSuspenseQueryHookResult = ReturnType<typeof useWarrantyModalTicketTypesAndDevelopmentsSuspenseQuery>;
export type WarrantyModalTicketTypesAndDevelopmentsQueryResult = Apollo.QueryResult<WarrantyModalTicketTypesAndDevelopmentsQuery, WarrantyModalTicketTypesAndDevelopmentsQueryVariables>;
export const WarrantyModalProjectsDocument = gql`
    query WarrantyModalProjects($filter: ProjectFilter) {
  projectsPage(filter: $filter) {
    entities {
      ...WarrantyModal_Project
    }
  }
}
    ${WarrantyModal_ProjectFragmentDoc}`;

/**
 * __useWarrantyModalProjectsQuery__
 *
 * To run a query within a React component, call `useWarrantyModalProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWarrantyModalProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWarrantyModalProjectsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useWarrantyModalProjectsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WarrantyModalProjectsQuery, WarrantyModalProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WarrantyModalProjectsQuery, WarrantyModalProjectsQueryVariables>(WarrantyModalProjectsDocument, options);
      }
export function useWarrantyModalProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WarrantyModalProjectsQuery, WarrantyModalProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WarrantyModalProjectsQuery, WarrantyModalProjectsQueryVariables>(WarrantyModalProjectsDocument, options);
        }
// @ts-ignore
export function useWarrantyModalProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WarrantyModalProjectsQuery, WarrantyModalProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WarrantyModalProjectsQuery, WarrantyModalProjectsQueryVariables>;
export function useWarrantyModalProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WarrantyModalProjectsQuery, WarrantyModalProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WarrantyModalProjectsQuery | undefined, WarrantyModalProjectsQueryVariables>;
export function useWarrantyModalProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WarrantyModalProjectsQuery, WarrantyModalProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WarrantyModalProjectsQuery, WarrantyModalProjectsQueryVariables>(WarrantyModalProjectsDocument, options);
        }
export type WarrantyModalProjectsQueryHookResult = ReturnType<typeof useWarrantyModalProjectsQuery>;
export type WarrantyModalProjectsLazyQueryHookResult = ReturnType<typeof useWarrantyModalProjectsLazyQuery>;
export type WarrantyModalProjectsSuspenseQueryHookResult = ReturnType<typeof useWarrantyModalProjectsSuspenseQuery>;
export type WarrantyModalProjectsQueryResult = Apollo.QueryResult<WarrantyModalProjectsQuery, WarrantyModalProjectsQueryVariables>;